import axios from "axios";
import { executeApiRequest } from "@/plumbing/http/apiClient";
import { CouncilConfigurationModel } from "@/api/CouncilConfiguration";

export type GetCouncilConfigurationResponse = {
  configuration: CouncilConfigurationModel;
};

export const getCouncilConfiguration = async () => {
  const response = await executeApiRequest(() => axios.get<GetCouncilConfigurationResponse>("/councilconfiguration"));

  return response?.data;
};
